import { useState } from "react";
import { PageHeader } from "../../../components/PortfolioPerformance/page-header";
import { LifetimeProjectionCharts } from "../../../components/PortfolioPerformance/lifetime-projection-charts";
import type { ThreeWayBasis } from "../../../components/PortfolioPerformance/basis-toggle";
import { useLifetimePrepaymentProjections } from "../lib/api/lifetime-prepayment-projections";
import { useBorrowerIndustries } from "../lib/api/borrower-industries";

const ALL_INDUSTRIES = "All Industries";

export default function LifetimePrepaymentProjectionsPage() {
  const [industry, setIndustry] = useState<string>(ALL_INDUSTRIES);
  const [basis, setBasis] = useState<ThreeWayBasis>("realized");
  const { data, isPending, isError } = useLifetimePrepaymentProjections(industry, basis);
  const borrowerIndustries = useBorrowerIndustries().data ?? [];

  return (
    <div>
      <PageHeader
        title="Prepayment Projections"
        subtitle="Principal early payment ÷ WAL, same mechanic as Expected Loss, but the loss here is unrealized interest income, never principal."
      />

      <div className="mt-8">
        <LifetimeProjectionCharts
          data={data}
          isPending={isPending}
          isError={isError}
          industry={industry}
          onIndustryChange={setIndustry}
          industryOptions={[ALL_INDUSTRIES, ...borrowerIndustries]}
          basis={basis}
          onBasisChange={setBasis}
          forecastTitle="Prepayment Forecast"
          projectionTitle="Prepayment Projection"
          sideBySide
        />
      </div>
    </div>
  );
}
